
let local = {
  save (key, value) {
    localStorage.setItem(key, JSON.stringify(value))
  },
  fetch (key) {
    return JSON.parse(localStorage.getItem(key)) || {}
  },
  clear () {
    console.log('主动 localStorage.clear()')
    localStorage.clear()
  },
  remove () {
    localStorage.removeItem(name)
  },
  isPhone (str) {
    var myreg = /^[1][3, 4, 5, 7, 8][0-9]{9}$/
    if (!myreg.test(str)) {
      return false
    } else {
      return true
    }
  },
  getPlatformId () {
    var ua = navigator.userAgent.toLowerCase()
    console.log('ua-getPlatformId', ua)
    if (ua.match(/DingTalk/i) == 'dingtalk') {
      return '4'
    } else if (ua.indexOf('smart-counselor/android') != -1) {
      return '2'
    } else if (ua.indexOf('smart-counselor/ios') != -1) {
      return '3'
    } else {
      return '1'
    }
  },
  getMember(){
    var ua = JSON.parse(navigator.userAgent)
    console.log('ua-getMember', ua)
    return ua.memberId
  },
  getToken(){
    var ua = JSON.parse(navigator.userAgent)
    console.log('ua-getToken', ua)
    return ua.token
  },
  getAppUAInfo(){
    return {
      platform: this.getPlatformId(),
      memberId: this.getMember(),
      token: this.getToken()
    }
  },
  IsPC(){  
    var userAgentInfo = navigator.userAgent;
    var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");  
    var flag = true;  
    for (var v = 0; v < Agents.length; v++) {  
       if (userAgentInfo.indexOf(Agents[v]) > 0) { flag = false; break; }  
    }  
    return flag
  }
}

export default {
  install: function (vm) {
    vm.prototype.$local = local
  },
  getLocal: local
}



// WEBPACK FOOTER //
// ./src/util/index.js